import React from 'react';
import { FeedbackQuestion } from '../../../types/feedback';

interface RatingQuestionProps {
  question: FeedbackQuestion;
  value: number;
  onChange: (value: number) => void;
  error?: string;
}

const RatingQuestion: React.FC<RatingQuestionProps> = ({
  question,
  value,
  onChange,
  error
}) => {
  const maxRating = question.validation?.max || 5;
  const minRating = question.validation?.min || 1;

  const handleStarClick = (rating: number) => {
    onChange(rating);
  };

  return (
    <div className="question-container">
      <label className="question-label">
        {question.question}
        {/* Removed required asterisk - all fields are now optional */}
      </label>
      
      <div className="rating-container">
        <div className="stars-container">
          {Array.from({ length: maxRating }, (_, index) => {
            const starValue = index + 1;
            return (
              <button
                key={index}
                type="button"
                className={`star ${starValue <= value ? 'filled' : 'empty'}`}
                onClick={() => handleStarClick(starValue)}
                aria-label={`Rate ${starValue} out of ${maxRating}`}
              >
                ⭐
              </button>
            );
          })}
        </div>
        
        <div className="rating-labels">
          <span className="rating-label-min">Poor</span>
          <span className="rating-label-max">Excellent</span>
        </div>
        
        {value > 0 && (
          <div className="rating-value">
            {value} out of {maxRating}
          </div>
        )}
      </div>
      
      {error && <div className="error-message">{error}</div>}
    </div>
  );
};

export default RatingQuestion;
